export enum ContextType {
    EDITOR = 'EDITOR',
    LEFT_NAVBAR = 'LEFT_NAVBAR',
    GUIDE_NAVBAR = 'GUIDE_NAVBAR',
    RIGHT_NAVBAR = 'RIGHT_NAVBAR',
    POPUP = 'POPUP',
    DROPDOWN = 'DROPDOWN'
}
